import {Button, ButtonVariant, closeCurrentDialog} from 'platform/components';
import {Box, Heading, HStack, Icon, Show, Text, ThemeIconKey, VStack} from 'platform/foundation';

interface DestroyDialogProps {
  iconPath: Extract<ThemeIconKey, 'alert_icon/circle'>;
  heading: string;
  description: string;
  onSubmitButtonTitle: string;
  onSubmitButtonVariant?: ButtonVariant;
  cancelButtonTitle: string;
  isLoading?: boolean;
  children?: React.ReactNode;
  onSubmit: () => void;
}

export function DestroyDialog(props: DestroyDialogProps) {
  return (
    <Box padding={4}>
      <VStack spacing={4} align="center">
        <Icon value={props.iconPath} size={20} isNotFilled />
        <Heading size={3}>{props.heading}</Heading>
        <Text align="center" color="secondary">
          {props.description}
        </Text>
        <Show when={props.children}>{props.children}</Show>
        <Box paddingTop={4}>
          <HStack spacing={2}>
            <Button
              variant="secondary"
              title={props.cancelButtonTitle}
              isDisabled={props.isLoading}
              onClick={closeCurrentDialog}
            />
            <Button
              variant={props.onSubmitButtonVariant ?? 'danger'}
              title={props.onSubmitButtonTitle}
              isLoading={props.isLoading}
              onClick={props.onSubmit}
            />
          </HStack>
        </Box>
      </VStack>
    </Box>
  );
}
